import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { HttpEventType, HttpHeaders } from '@angular/common/http';
import { ArtikelExcelImportPreviewDialogComponent } from '../artikel-excel-import-preview-dialog/artikel-excel-import-preview-dialog.component';
import { Material } from '../../material';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-heimtier-kunde-dialog',
    templateUrl: './artikel-excel-import-dialog.component.html',
    styleUrls: ['./artikel-excel-import-dialog.component.scss'],
})
export class ArtikelExcelImportDialogComponent implements OnInit {
    protected readonly columnOptions: string[] = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
    ];

    protected bezeichnungColumn: string;
    protected preisColumn: string;
    protected ustColumn: string;
    protected kuerzelColumn: string;
    protected faktorColumn: string;
    protected warengruppeColumn: string;
    protected fileSelectionEnabled = true;

    protected file: File;

    private isLoading = false;

    @ViewChild('fileSelector') fileSelector: ElementRef;

    constructor(
        public dialogRef: MatDialogRef<ArtikelExcelImportDialogComponent>,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private dialog: MatDialog,
        private api: KieneBackendApiService,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {}

    public isDisabled(): boolean {
        return !(this.file && this.bezeichnungColumn && !this.isLoading);
    }
    openFileSelector() {
        this.fileSelector.nativeElement.click();
    }

    handleFile(event: any) {
        this.file = event.target.files[0];
    }

    public check(): void {
        this.isLoading = true;

        const fd = new FormData();
        fd.append('dokument', this.file);
        if (this.bezeichnungColumn) {
            fd.append('bezeichnungColumn', this.bezeichnungColumn);
        }
        if (this.preisColumn) {
            fd.append('preisColumn', this.preisColumn);
        }
        if (this.ustColumn) {
            fd.append('ustColumn', this.ustColumn);
        }
        if (this.kuerzelColumn) {
            fd.append('kuerzelColumn', this.kuerzelColumn);
        }
        if (this.faktorColumn) {
            fd.append('faktorColumn', this.faktorColumn);
        }
        if (this.warengruppeColumn) {
            fd.append('warengruppeColumn', this.warengruppeColumn);
        }

        const options = { headers: new HttpHeaders('Phito-Type: fileupload'), reportProgress: true };

        this.api.postFormData(this.apiBaseUrl + 'artikel/preimport_excel.php', fd, options).subscribe({
            next: event => {
                if (event.type === HttpEventType.UploadProgress) {
                    const percentDone = Math.round((100 * event.loaded) / event.total);
                    console.log(percentDone);
                } else {
                    let artikel: Material = event;
                    let dialogRef = this.dialog.open(ArtikelExcelImportPreviewDialogComponent, {
                        width: '90%',
                        data: artikel,
                    });

                    dialogRef.afterClosed().subscribe(result => {
                        if (result) {
                            this.actuallyUpload(fd);
                        } else {
                            this.isLoading = false;
                        }
                    });
                }
            },
            error: err => {
                this.isLoading = false;
                this.fileSelectionEnabled = false;
                this.messageService.errorMessage('Fehler beim Hochladen!', err);
            },
        });
    }

    public actuallyUpload(fd): void {
        const options = { headers: new HttpHeaders('Phito-Type: fileupload'), reportProgress: true };

        this.messageService.infoMessage('Daten werden importiert!');
        this.api.postFormData(this.apiBaseUrl + 'artikel/import_excel.php', fd, options).subscribe({
            next: event => {
                if (event.type === HttpEventType.UploadProgress) {
                    const percentDone = Math.round((100 * event.loaded) / event.total);
                    console.log(percentDone);
                }
            },
            error: err => {
                this.isLoading = false;
                this.fileSelectionEnabled = false;
                this.messageService.errorMessage('Fehler beim Hochladen!', err);
            },
            complete: () => {
                this.isLoading = false;
                this.messageService.infoMessage('Datei(en) erfolgreich hochgeladen!');
                this.dialogRef.close(true);
            },
        });
    }
}
